var Marionette = require('backbone.marionette');

var Document = require('../../models/document-model');
var DocumentData = require('./document-data');
var DocumentSignData = require('./document-sign-data');
var ReviewRequestModel = require('../../models/review-request-model');
var YesNoConfirmationModal = require('../common/yes-no-confirmation-modal');
var PermissionsCollection = require('../../collections/permissions-collection');
var PermissionFormView = require('../permissions/permission-form');
var PermissionsTableView = require('../permissions/permissions-table-view');
var ReviewerFormView = require('../review/reviewer-form-view');
var DocumentReviewersView = require('./document-reviewers-view');
var AddendumsView = require('./addendums-view');
var ReviewElementStatusesModel = require('../../models/review-element-statuses-model');
var CommonUtils = require('../../utils/common-utils.js');
var DocumentPatientForm = require('./document-patient-form');
var CommentFormView = require('../comments/comment-form');
var CommentsTableView = require('../comments/comments-table-view');
var DocumentHistoryView = require('./history/document-history-view');
var DocumentActionByDocumentView = require('./document-action-by-document-view');

var ContactsTableView = require('../contacts/contacts-table-view');
var ContactsCollection = require('../../collections/contacts-collection');
var ContactFormView = require('../contacts/contact-form');

var Radio = require('backbone.radio');
var sessionChannel = Radio.channel('session');
var notificationsChannel = Radio.channel('notifications');

var DocumentView = Marionette.View.extend({
    template: require('../../templates/documents/document.html'),
    model: new Document(),
    reviewRequestModel: new ReviewRequestModel(),
    commonUtil: new CommonUtils(),

    regions: {
        documentData: '#document-data',
        documentSignData: '#document-sign-data',
        requests: '#document-requests',
        newRequest: '#create-request',
        additionalElements: '#additional-elements',
        reviewRequesterOrgSelect: '#review-requester-org',
        confirmationModal: '#save-confirmation-modal',
        permissions: '#permissions',
        addPermission: '#add-permission',
        addReviewersForm: '#add-reviewers-form',
        reviewers: '#reviewers',
        documentPatient: '#document-patient',
        comments: '#comments',
        addComment: '#add-comment',
        historyView: '#history',
        documentActionByDocument: '#document-action-by-document-content',
        contacts: '#contacts',
        contactForm: '#contact-form'
    },

    childViewEvents: {
        'document:will-be-remove': 'removeDocument',
        'entity:selected': 'entitySelected',
        'action:confirmed': 'saveConfirmed',
        'permission:saved': 'permissionSaved',
        'review:status:updated': 'onReviewStatusChanged',
        'patient:added:to:doc': 'refreshDocumentPatientForm',
        'comment:added': 'onCommentAdded',
        'comment:count:changed': 'onCommentCountChanged',
        'reviewer:changed': 'onReviewerChanged',
        'on:cancel:comment:send': 'onCancelCommentSend',
        'on:edit:comment': 'onEditComment',
        'comment:updated': 'onCommentUpdated',
        'on:new:comment': 'onNewComment',
        'action:with:document:upload': 'onActionWithDocumentUpload',
        'on:contact:action': 'onContactAction',
        'on:contact:saved': 'onContactSaved'
    },

    ui: {
        modal: '#addReviewRequestModal',
        additionalElements: '#additional-elements',
        documentSignData: '#document-sign-data',
        documentSignDataTab: '#item-sign-settings',
        alias: '#alias',
        aliasUpdate: '#alias-update',
        aliasCancel: '#alias-cancel',
        commentsCount: '#comments-count',
        addReviewerButton: '#add-reviewer-button',
        contactForm: '#contact-form'
    },

    events: {
        'click #new-request': 'requestShow',
        'click #save-request': 'saveRequest',
        'click @ui.addReviewerButton': 'addReviewer',
        'keyup @ui.alias': 'onAliasChange',
        'click @ui.aliasUpdate': 'aliasUpdate',
        'click @ui.aliasCancel': 'aliasCancel',
        'comment:count:changed': 'onCommentCountChanged'
    },

    userCanEdit: undefined,

    initReviewer: function () {
        return {
            personId: "",
            organizationId: "",
            mandatory: true
        }
    },


    initialize: function (options) {
        _.bindAll(this, 'onRender', 'removeDocument',
            'permissionSaved', 'renderReviewers',
            'addReviewer', 'onReviewStatusChanged', 'canEdit', 'save', 'refreshDocumentPatientForm', 'isShowSignData',
            'onCommentAdded', 'canUploadForOrganizationInDocument', 'renderPermissionsListView',
            'onAliasChange', 'aliasUpdate', 'aliasCancel', 'onCommentCountChanged', 'onReviewerChanged', 'onActionWithDocumentUpload');
        this.model = options.model;
        this.reviewRequestModel.view = this;
        this.reviewRequestModel.on('invalid', this.showErrors);
        this.reviewElementStatuses = new ReviewElementStatusesModel();
        this.utils = new CommonUtils();
        this.permissions = sessionChannel.request('get:permissions');
        this.userId = sessionChannel.request('get:userId');
        this.byAdmin = options.byAdmin;

        $.when(this.reviewElementStatuses.fetch()).then(this.renderReviewers);
    },

    templateContext: function () {
        var that = this;
        return {
            canEdit: function () {
                return that.canEdit();
            },
            canUploadForOrganizationInDocument: function () {
                return that.canUploadForOrganizationInDocument();
            },
            isShowSignData: that.isShowSignData,
            contactsCount: (that.model.get('object').contacts || []).length
        }
    },

    showErrors: function (model, errors) {
        model.view.triggerMethod('server:error', errors.join('. \n'));
    },

    onRender: function () {
        window.document.title = this.model.get("name");
        var that = this;

        that.initEvents();

        that.$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            var target = that.$(e.target).attr("href");
            if (target == '#document-history' /* && typeof that.getChildView('historyView') == 'undefined'*/) {
                that.showChildView('historyView', new DocumentHistoryView({
                    id: that.model.get('id'),
                    name: that.model.get('name'),
                    baseParentIdPath: '/api/document/view/',
                    canEdit: that.canEdit(),
                    byAdmin: that.byAdmin,
                    document: that.model.get('object')
                }));
            } else if (target == '#document-permissions' && typeof that.getChildView('addPermission') == 'undefined') {
                if (that.canEdit()) {
                    that.permissionsCollection = new PermissionsCollection([], {
                        params: [{
                            key: 'permittedObjectId',
                            value: that.model.id
                        }]
                    });
                    that.renderPermissionsListView(that.permissionsCollection);

                    that.permissionFormView = new PermissionFormView({
                        'permittedObjectId': that.model.id,
                        showOrganization: true,
                        permittedObjectType: 'document'
                    });
                    that.showChildView('addPermission', that.permissionFormView);
                }
            } else if (target == '#document-patients' && typeof that.getChildView('documentPatient') == 'undefined') {
                if (that.canEdit()) {
                    that.documentPatient = new DocumentPatientForm({model: that.model, canEdit: that.canEdit});
                    that.showChildView('documentPatient', that.documentPatient);
                }
            } else if (target == '#document-comments' && typeof that.getChildView('comments') == 'undefined') {
                that.renderCommentsView();
            } else if (target == '#document-action-by-document' && typeof that.getChildView('documentActionByDocument') == 'undefined') {
                that.showChildView('documentActionByDocument', new DocumentActionByDocumentView({
                    model: that.model,
                    canEdit: that.canEdit
                }));
            }
        });
        this.renderContacts();
    },

    renderReviewers: function () {
        this.documentDataView = new DocumentData({
            model: this.model,
            canEdit: this.canEdit,
            canUploadForOrganizationInDocument: this.canUploadForOrganizationInDocument,
            isMd: this.permissions.isMd,
            userId: this.userId,
            byAdmin: this.byAdmin
        });
        this.showChildView('documentData', this.documentDataView);

        if (this.canEdit()) {
            this.confirmationModal =
                new YesNoConfirmationModal({message: 'Requester organization is not selected. Are you sure you want to send request without organization?'});
            this.showChildView('confirmationModal', this.confirmationModal);

            if (this.isShowSignData()) {
                this.documentSignDataView = new DocumentSignData({model: this.model, canEdit: this.canEdit});
                this.showChildView('documentSignData', this.documentSignDataView);
            }
            else {
                this.ui.documentSignData.remove();
                this.ui.documentSignDataTab.remove();
            }
        }

        if (this.canEdit() || this.canUploadForOrganizationInDocument()) {
            this.reviewer = this.initReviewer();
            this.reviewerFormView = new ReviewerFormView({
                reviewer: this.reviewer,
                regionId: "addReviewer",
                showRemove: false
            });
            this.showChildView('addReviewersForm', this.reviewerFormView);
        }

        this.reviewersView = new DocumentReviewersView({
            documentId: this.model.get('id'),
            reviewers: this.model.get('object').reviewers,
            idNamesMap: this.getIdNamesMap(),
            elementStatuses: this.reviewElementStatuses.toJSON(),
            permissions: this.permissions,
            relations: this.model.get('relations'),
            canEdit: this.canEdit,
            canUploadForOrganizationInDocument: this.canUploadForOrganizationInDocument,
            byAdmin: this.byAdmin
        });
        this.showChildView('reviewers', this.reviewersView);
    },

    initEvents: function () {
        this.triggerMethod('comment:count:changed');
    },

    renderCommentsView: function () {

        this.showChildView('comments', new CommentsTableView({
            dboId: this.model.get('id'),
            canEdit: this.canEdit()
        }));

        this.renderCommentForm();
    },

    renderCommentForm: function (model) {
        this.showChildView('addComment', new CommentFormView({
            dboId: this.model.get('id'),
            model: model ? model : new Backbone.Model({
                id: undefined,
                text: undefined
            })
        }));
    },

    refreshDocumentPatientForm: function (model) {
        var that = this;
        that.showChildView('documentPatient', new DocumentPatientForm({
            model: new Backbone.Model(model),
            canEdit: that.canEdit
        }));
    },

    renderPermissionsListView: function (collection) {
        this.permissionsListView = new PermissionsTableView({
            collection: collection,
            showOrganization: true,
            permittedObjectType: 'document'
        });
        this.showChildView('permissions', this.permissionsListView);
    },

    requestShow: function () {
        this.ui.modal.modal({backdrop: 'static', keyboard: false});
    },

    saveRequest: function () {
        if (typeof this.reviewRequestModel.get('object').requesterOrganizationId === "undefined") {
            $(this.ui.modal).modal('hide');
            this.$('#confirmation-modal').modal();
        }
        else
            this.save();
    },

    save: function () {
        var that = this;
        var name = (that.reviewRequestModel.get('object').reviewRequestElements || [])
            .map(function (element) {
                return element.documentName
            })
            .join(', ');
        that.reviewRequestModel.set('name', name == '' ? 'Review request' : name);
        that.reviewRequestModel.save(that.reviewRequestModel.toJSON(), {success: that.requestSaved});
    },

    removeDocument: function (data) {
        var that = this;
        var regionId = data.regionId;
        var element = data.element;
        that.deleteRegion(regionId);
        this.tempRegionNames = this.tempRegionNames.filter(function (item) {
            return item !== regionId;
        });
        this.reviewRequestModel.get('object').reviewRequestElements = this.reviewRequestModel.get('object').reviewRequestElements.filter(function (item) {
            return item !== element;
        });
    },

    storeRegion: function (regionName) {
        this.tempRegionNames = this.tempRegionNames || [];
        this.tempRegionNames.push(regionName);
    },

    deleteRegion: function (regionId) {
        this.getRegion(regionId).empty();
        this.removeRegion(regionId);
        this.$('#' + regionId).remove();
    },

    entitySelected: function (data) {
        this.reviewRequestModel.get('object').requesterOrganizationId = data.id;
    },

    saveConfirmed: function (data) {
        if (data.result == true) {
            this.save();
        }
        else {
            $(this.ui.modal).modal('show');
        }
    },

    permissionSaved: function (model) {
        this.renderPermissionsListView(this.permissionsCollection);
    },

    addReviewer: function () {
        var that = this;
        that.utils.showSpinner();
        $.ajax({
            type: "POST",
            url: '/api/document/' + this.model.get('id') + '/reviewer',
            data: JSON.stringify(this.reviewer),
            contentType: 'application/json',
            statusCode: {
                200: function (response) {
                    that.utils.hideSpinner();
                    that.model.set(response);
                    that.reviewer = that.initReviewer();
                    that.renderReviewers();
                    that.ui.addReviewerButton.attr('disabled', true);
                }
            },
            error: function (e) {
                console.log(e);
                notificationsChannel.request('show:notification', e.responseJSON);
                that.utils.hideSpinner();
            }
        });
    },

    getIdNamesMap: function () {
        var idNamesMap = {};
        (this.model.get('relations') || []).forEach(function (relation) {
            idNamesMap[relation.child.id] = relation.child.name;
        });
        return idNamesMap;
    },

    onReviewStatusChanged: function (object) {
        this.model.set(object);
        this.renderReviewers();
    },

    canEdit: function () {
        if (!this.userCanEdit) {
            this.userCanEdit = this.commonUtil.userCanDoWithDocument(this.permissions,
                function (permission) {
                    return permission.canWriteFor || permission.canSign;
                },
                function (permission) {
                    return permission.canWriteAll || permission.canSignAll;
                },
                this.model.get('permissions'),
                function (permission) {
                    return permission.canWrite || permission.canSign;
                }
            );
        }
        return this.userCanEdit;
    },

    isShowSignData: function () {
        var that = this;
        return that.model.get('object').reviewers.filter(function (reviewer) {
            return reviewer.status == 'SIGNED';
        }).length == 0;
    },

    onCommentAdded: function (commentModel) {
        this.getChildView('comments').add(commentModel);
        this.renderCommentForm();
    },

    onCommentUpdated: function (commentModel) {
        this.getChildView('comments').update(commentModel);
        this.renderCommentForm();
    },

    onCommentCountChanged: function () {
        var that = this;

        $.ajax({
            type: "GET",
            url: '/api/comment/' + that.model.get('id') + '/count',
            statusCode: {
                200: function (response) {
                    that.ui.commentsCount.text(response);
                    if (typeof that.getChildView('comments') != 'undefined') {
                        that.getChildView('comments').syncWithCount(response);
                    }
                }
            },
            error: function (e) {
                console.log(e);
            }
        });
    },

    canUploadForOrganizationInDocument: function () {
        if (!this.userCanUpload) {
            var organizationId = this.model.get('object').organizationId || '';
            this.userCanUpload = (this.permissions.userPermissions || [])
                .filter(function (permission) {
                    return permission.canUploadFor && permission.permittedObjectId == organizationId;
                }).length > 0;
        }
        return this.userCanUpload;
    },

    onAliasChange: function (event) {
        if (event.target.value != this.model.get('alias')) {
            this.ui.aliasCancel.removeAttr('disabled');
            this.ui.aliasUpdate.removeAttr('disabled');
        } else {
            this.ui.aliasCancel.attr('disabled', true);
            this.ui.aliasUpdate.attr('disabled', true);
        }
    },

    aliasUpdate: function (event) {
        var that = this;
        var alias = that.ui.alias.val();
        that.utils.showSpinner();
        $.ajax({
            type: "POST",
            url: '/api/document/' + that.model.get('id') + '/alias',
            data: alias,
            contentType: 'text/plain',
            statusCode: {
                200: function (response) {
                    that.utils.hideSpinner();
                    that.model.set('alias', alias);
                    that.ui.aliasCancel.attr('disabled', true);
                    that.ui.aliasUpdate.attr('disabled', true);
                }
            },
            error: function (e) {
                that.utils.hideSpinner();
                notificationsChannel.request('show:notification', e.responseJSON);
            }
        });
    },

    aliasCancel: function (event) {
        this.ui.alias.val(this.model.get('alias'));
        this.ui.aliasCancel.attr('disabled', true);
        this.ui.aliasUpdate.attr('disabled', true);
    },

    onReviewerChanged: function () {
        if (this.reviewer.organizationId || this.reviewer.personId)
            this.ui.addReviewerButton.removeAttr('disabled');
        else
            this.ui.addReviewerButton.attr('disabled', true);
    },

    onCancelCommentSend: function () {
        this.renderCommentForm();
    },

    onEditComment: function (model) {
        this.renderCommentForm(model);
        $('html, body').animate({scrollTop: $(document).height()}, 'slow');
    },

    onNewComment: function () {
        this.renderCommentForm();
        $('html, body').animate({scrollTop: $(document).height()}, 'slow');
    },

    onActionWithDocumentUpload: function (data) {
        this.triggerMethod('refresh:document:view', data.id);
    },

    renderContacts: function () {
        this.contactsView = new ContactsTableView({
            collection: new ContactsCollection(this.model.get('object').contacts),
            canEdit: this.canEdit()
        });
        this.showChildView("contacts", this.contactsView);
    },

    renderContactForm: function (mode, contact) {
        this.ui.contactForm.show();
        if (mode == 'add') {
            this.contactFormView = new ContactFormView({
                mode: mode,
                addresses: this.model.get('object').addresses || [],
                representatives: this.model.get('object').representatives || []
            });
            this.showChildView("contactForm", this.contactFormView);
        }
        else if (mode == 'edit') {
            this.contactFormView = new ContactFormView({
                mode: mode,
                contact: contact,
                addresses: this.model.get('object').addresses || [],
                representatives: this.model.get('object').representatives || []
            });
            this.showChildView("contactForm", this.contactFormView);
        }
    },

    removeContactForm: function () {
        this.ui.contactForm.hide();
        this.detachChildView('contactForm');
    },

    onContactAction: function (data) {
        var that = this;
        if (data.mode == 'add') {
            that.renderContactForm(data.mode);
        }
        else if (data.mode == 'delete') {
            var willBeRemoveContact = data.data.attributes;
            that.model.get('object').contacts = (that.model.get('object').contacts || []).filter(function (contact) {
                return contact.data !== willBeRemoveContact.data
                    || contact.type !== willBeRemoveContact.type
                    || contact.preferred !== willBeRemoveContact.preferred;
            });
            that.model.save(that.model.toJSON(), {
                success: function () {
                    that.renderContacts();
                }
            });
        }
        else if (data.mode == 'edit') {
            var willBeEditedContact = data.data.attributes;
            var willEditContact = (that.model.get('object').contacts || []).filter(function (contact) {
                return contact.data == willBeEditedContact.data
                    && contact.type == willBeEditedContact.type
                    && contact.preferred == willBeEditedContact.preferred;
            });
            this.renderContactForm(data.mode, willEditContact[0]);
        }
        else if (data.mode == 'cancel') {
            that.removeContactForm();
        } else if (data.mode == 'save') {
            var changedContact = data.data.attributes;
            (that.model.get('object').contacts || []).forEach(function (contact) {
                if (contact.data == changedContact.data
                    && contact.type == changedContact.type) {
                    contact.preferred = changedContact.preferred;
                }
            });
            that.model.save(that.model.toJSON(), {
                success: function () {
                    that.renderContacts();
                }
            });
        }
    },

    onContactSaved: function (data) {
        var that = this;
        if (data.mode == 'add') {
            that.model.get('object').contacts = (that.model.get('object').contacts || []).filter(function (contact) {
                return contact.data !== data.contact.data
                    || contact.type !== data.contact.type
                    || contact.preferred !== data.contact.preferred;
            });
            that.model.get('object').contacts.push(data.contact);
            that.model.save(that.model.toJSON(), {
                success: function () {
                    that.renderContacts();
                    that.removeContactForm();
                }
            });
        } else if (data.mode == 'edit') {
            that.model.save(that.model.toJSON(), {
                success: function () {
                    that.renderContacts();
                    that.removeContactForm();
                }
            });
        }
    }
});

module.exports = DocumentView;


//////////////////
// WEBPACK FOOTER
// ./app/views/documents/document-view.js
// module id = 392
// module chunks = 0